module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees-list"
  }, _vm._l((_vm.fields), function(field) {
    return _c('div', {
      staticClass: "field"
    }, [_c('h3', [_vm._v(_vm._s(field.name))]), _vm._l((_vm.employees[field.name]), function(employee) {
      return _c('div', {
        key: employee.id,
        staticClass: "employee"
      }, [_c('span', {
        staticClass: "name"
      }, [(_vm.user.is_superuser) ? _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.loginAs(employee.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-eye"
      })]) : _vm._e(), _vm._v(" " + _vm._s(employee.short_name))]), _c('span', {
        staticClass: "cell-phone"
      }, [_c('a', {
        attrs: {
          "href": 'tel:' + employee.cell_phone
        }
      }, [_vm._v(_vm._s(employee.cell_phone))])]), _c('span', {
        staticClass: "email"
      }, [_c('a', {
        attrs: {
          "href": 'mailto:' + employee.email
        }
      }, [_c('i', {
        staticClass: "fa fa-envelope"
      })])])])
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1522c9c6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmployeesList.vue
// module id = 1079
// module chunks = 1